module.exports = __webpack_public_path__ + "static/media/icon_133.8888f502.svg";